import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostAuthPassword_reset = z.any()
export type TagsPostAuthPassword_reset = z.infer<typeof tagsPostAuthPassword_reset>

export const bodyPostAuthPassword_reset = z.object({ "email": z.string().email() })
export type BodyPostAuthPassword_reset = z.infer<typeof bodyPostAuthPassword_reset>

export const responsePostAuthPassword_reset = z.any()
export type ResponsePostAuthPassword_reset = z.infer<typeof responsePostAuthPassword_reset>

interface IPostAuthPassword_reset extends BaseMethodType {
  tags: TagsPostAuthPassword_reset,
  body: BodyPostAuthPassword_reset,
  response: ResponsePostAuthPassword_reset
}
export const URL = '/auth/password-reset'
export const validation = {
  post: {
    tags: tagsPostAuthPassword_reset,
    body: bodyPostAuthPassword_reset,
    response: responsePostAuthPassword_reset
  }
}
export interface AuthPassword_reset extends BaseRouteType {
  post: IPostAuthPassword_reset
}